// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3LffI","swatch":"swatch___2UvnB","swatchLabel":"swatchLabel___Fb9k1","swatchDate":"swatchDate___1I9g5","checkBox":"checkBox___1cI8D","contextMenu":"contextMenu___sfAtH","contentMenuItem":"contentMenuItem___2fsO8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Swatch/Swatch.module.css
// module id = 322
// module chunks = 0